<template>
  <div class="page-content">
    <!-- header -->
    <div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
      <div class="my-2 d-flex align-items-center">
        <div class="top_heading_CreatePartner_btn d-block me-2">
          <div class="Group_top_three_dot">
            <div class="dropdown">
              <router-link :to="{
                name: 'ActiveTestViewCandidatesNew',
                params: {
                  clientId: encode(this.clientId),
                  isParent: encode(isParent), //update
                },
                query: {
                  search: encode(this.routesearch),
                  offset: encode(this.routeoffset),
                  current: encode(this.routecurrent),
                },
              }" class="p-0 Group_top_three_dot_dropdown-active btn-back-arrow-kj" type="button"
                style="line-height: 2.6">
                <i class="fa-solid fa-chevron-left"></i>
              </router-link>
            </div>
          </div>
        </div>
        <div>
          <h4 class="mb-2 fw-bolder">Report</h4>
          <h6 class="text-muted">
            {{ this.testName }} <i class="fa-solid fa-angle-right mx-2"></i>
            {{ this.name }}
          </h6>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <div class="top_heading_CreatePartner_btn d-block mx-3" data-bs-toggle="modal"
          data-bs-target="#ConsolidatedSheet">
          <div class="Group_top_three_dot">
            <div class="dropdown">
              <!-- <button class="btn p-0 Group_top_three_dot_dropdown" type="button" @click="savePdf()">
                <img src="../../public/dashboard-assets/images/M2/download-icon.png" />
              </button> -->
              <a :href="reportUrl" target="_blank">
                <button class="btn p-0 Group_top_three_dot_dropdown" type="button">
                  <img src="../../public/dashboard-assets/images/M2/download-icon.png" />
                </button>
              </a>
              <!-- <router-link :to="{
                name: 'BehaviouralPDF',
                query: {
                  candidateId: encode(this.candidateId),
                  testId: encode(this.testId),
                  name: encode(this.name),
                  clientId: encode(this.clientId),
                  isParent: encode(this.isParent),
                  id: encode(this.routesearch),
                  offset: encode(this.routecurrent),
                  current: encode(this.routecurrent)
                },
              }">
                <button class="btn p-0 Group_top_three_dot_dropdown" type="button">
                  <img src="../../public/dashboard-assets/images/M2/download-icon.png" />
                </button>
              </router-link> -->
            </div>
          </div>
        </div>


        <div class="top_heading_CreatePartner_btn d-block">
          <div class="Group_top_three_dot">
            <div class="dropdown">
              <button class="btn p-0 Group_top_three_dot_dropdown" type="button" id="dropdownMenuButton"
                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa-solid fa-ellipsis-vertical fa-lg" style="color: #7c7c7c;"></i>
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li>
                  <a :href="compeleteReportUrl" target="_blank">
                    <button type="button" class="btn w-100 text-start">
                      Download Consolidated Report
                    </button>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="row Report_card_section">
      <div class="col-md-12">
        <div class="card active-card">
          <!--Header Component-->
          <div class="card mb-3">
            <ActiveTestHeaderVue :active="this.actived" :testId="this.testId" :candidateId="this.candidateId"
              :isParent="this.isParent" :clientId="this.clientId" :id="this.routesearch" :current="this.routecurrent"
              :offset="this.routeoffset" />
          </div>
          <!--Header Component-->
          <div class="card" :class="[this.showFeatureContentAll == false ? 'disable-text-selection' : '']"
            :style="{ filter: this.showFeatureContentAll == false ? 'blur(8px)' : '' }">
            <div class="Report_basic_info_area my-4">
              <div class="Report_basic_info_heading">
                <h4>
                  How to Interpret the Report?
                  <!-- <img
                  src="../../public/dashboard-assets/images/M7/Actions.png"
                  width="30"
                  class="ms-2 cursor-pointer "
                  alt=""
                /> -->
                </h4>
              </div>
              <div class="Score_Rank_chart_area">
                <b class="font-size-17">
                  When interpreting the results, it is important to remember
                  that the scores are not good or bad, only more or less
                  appropriate to certain types of work. Since the results are
                  based on one's own view of behavior, the accuracy of the
                  results depends upon both honesty and self-awareness while
                  taking the test. This assessment measures work-relevant
                  personality traits that might be manifested in work behaviour
                  and therefore influence success on the job. To best use this
                  report:
                </b>
                <ul class="mt-3 text-muted font-size-17">
                  <li class="my-2">
                    Review the overall recommendation first. Based on your need,
                    you might want to prioritize candidates who are
                    ‘recommended', followed by those who are ‘cautiously
                    recommended’.
                  </li>
                  <li class="my-2">
                    If you’re choosing among different candidates within the
                    same band of recommendation, review the competencies’
                    results. Focus on the competencies you believe are critical
                    for success in the role you’re hiring for, and use those
                    scores to help you prioritize which candidates to select for
                    the next step.
                  </li>
                  <li class="my-2">
                    Remember: This assessment is just one piece of the puzzle.
                    While hiring, it is recommended that you review other
                    information as well –functional and job knowledge,
                    background and past behaviour (e.g. using structured
                    behavioural interviews), reference checks, etc. in addition
                    to the personality assessment.
                  </li>
                </ul>
              </div>
            </div>
            <div class="Report_basic_info_area my-4" v-if="
              GenuineData?.responseStyles?.length != 0 &&
              GenuineData?.responseStyles != null
            ">
              <div class="Report_basic_info_heading">
                <h4>
                  Response Style
                  <img src="../../public/dashboard-assets/images/M7/Actions.png" width="25" class="cursor-pointer ms-2"
                    alt="" data-bs-toggle="tooltip" data-bs-placement="top"
                    title="Refers to the tendency of the candidate to respond to questions in a particular way. " />
                  <span :class="[
                    GenuineData.genuineness === 'This Assessment is Genuine'
                      ? 'Recommended_heading_text ms-3'
                      : 'Not_recommended_heading_text ms-3',
                  ]">
                    {{ GenuineData.genuineness }}
                  </span>
                </h4>
              </div>
              <div class="table-responsive mt-3 Attempt_Details_table_area">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th scope="col" class="response-table-headers" v-for="item in GenuineData?.responseStyles"
                        :key="item">
                        {{ item.competencyName }}
                        <img src="../../public/dashboard-assets/images/M7/Actions.png" width="20"
                          class="cursor-pointer ms-2" alt="" data-bs-toggle="tooltip" data-bs-placement="top"
                          :title="item.definition" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td v-for="item in GenuineData?.responseStyles" :key="item">
                        <div scope="row" :class="[
                          item.fitment === 'Genuine'
                            ? 'text-muted'
                            : 'show-not-genuine-fitment',
                        ]">
                          {{ item.percentage }}
                          <span>({{ item.fitment }})</span>
                        </div>
                        <!-- <div v-else>
                            NA
                          </div>
                        </div> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="Overall_Cognitive_section my-4 mb-2">
              <div class="Overall_Cognitive_header">
                Overall Competency Score
              </div>

              <div class="Overall_Cognitive_detail mt-4">
                <div class="Overall_Cognitive_detail_Definition pb-3">
                  <span class="Recommended_heading_text"> Definition </span>
                  <p class="Overall_Cognitive_detail_Definition_content">
                    {{
                      this.behaviouralData.definition
                        ? this.behaviouralData.definition
                        : "NA"
                    }}
                  </p>
                </div>
                <div class="Overall_Cognitive_detail_Definition mb-4 d-flex">
                  <div class="row">
                    <div class="col-xl-10 col-lg-9 col-md-12 mt-4">
                      <span class="Recommended_heading_text">
                        Score Description
                      </span>
                      <div v-if="this.behaviouralData?.comment?.length > 0" class="mt-4">
                        <p v-html="this.behaviouralData?.comment" class="Overall_Cognitive_detail_Definition_content">
                        </p>
                      </div>
                      <div v-else class="mt-4">
                        <p class="Overall_Cognitive_detail_Definition_content">
                          {{ "NA" }}
                        </p>
                      </div>
                    </div>
                    <div class="col-xl-2 col-lg-3 col-md-12 text-center mt-4">
                      <!-- <img
                      src="../../public/dashboard-assets/images/M7/Overall_Cognitive.png"
                      width="130"
                      class="ms-4"
                      alt=""
                    /> -->
                      <CustomChartVue :score="this.score" v-if="this.show" :main="'score'" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="Report_basic_info_area my-4">
              <div class="Score_Rank_chart_area linechart">
                <!-- <img
                src="../../public/dashboard-assets/images/M7/Behavioural_Overall_Score_chart.png"
                class="w-100"
                alt=""
              /> -->
                <div id="legend-container"></div>
                <canvas id="myChart"></canvas>
              </div>
            </div>
            <div v-for="(item, index) in this.behaviouralCompetencies" :key="index">
              <div class="Overall_Cognitive_section my-4">
                <div class="Overall_Cognitive_header">
                  {{ item.competencyName }}
                </div>

                <div class="Overall_Cognitive_detail mt-4">
                  <div class="Overall_Cognitive_detail_Definition pb-3">
                    <span class="Recommended_heading_text"> Definition </span>
                    <p class="Overall_Cognitive_detail_Definition_content" v-html="item.definition">
                    </p>
                  </div>
                  <div class="Overall_Cognitive_detail_Definition mb-5 d-flex">
                    <div class="row">
                      <div class="col-xl-10 col-lg-9 col-md-12 mt-4">
                        <span class="Recommended_heading_text">
                          Score Description
                        </span>
                        <div v-if="item?.comment?.length > 0" class="mt-4">
                          <p class="Overall_Cognitive_detail_Definition_content" v-html="item.comment"></p>
                        </div>
                        <div v-else class="mt-4">
                          <p class="Overall_Cognitive_detail_Definition_content"> {{ "NA" }} </p>
                        </div>
                      </div>
                      <div class="col-xl-2 col-lg-3 col-md-12 text-center mt-4">
                        <CustomChartVue :score="this.subScore[index]" v-if="this.subShow[index]"
                          :main="item.competencyName" />

                      </div>
                    </div>
                  </div>
                  <div class="Overall_Cognitive_detail_Definition pb-3 mt-4" v-if="item.keyFocusArea != null">
                    <span class="Recommended_heading_text">
                      Key Focus Area
                    </span>
                    <div class="mt-5">
                      <ul class="StepProgress">
                        <li class="StepProgress-item is-done" v-for="focus in item.keyFocusArea" :key="focus">
                          {{ focus }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="Report_basic_info_area mb-4" v-if="
                item?.competencyTraits != null &&
                item?.competencyTraits?.length != 0
              ">
                <div class="Score_Rank_chart_area p-0">
                  <div class="row m-0 align-items-start Self_Score_tabs_section">
                    <div class="col-xl-3 col-lg-3 col-md-12 Self_Score_tabs_left_part nav flex-column nav-pills"
                      id="v-pills-tab" role="tablist" aria-orientation="vertical">
                      <h3 class="text-muted">{{ item.competencyName }}</h3>

                      <button class="nav-link mt-3" :class="{
                        active: this.enabled[subParam.competencyId],
                      }" v-for="(subParam, index) in item.competencyTraits" :key="index"
                        :id="subParam.competencyName + subParam.competencyId" @click="
                          scrolling(subParam.competencyId, item.competencyId)
                          " data-bs-toggle="pill" data-bs-target="#Self_Control" type="button" role="tab"
                        aria-controls="Self_Control" aria-selected="true">
                        {{ subParam.competencyName }}
                      </button>
                    </div>

                    <div class="col-xl-9 col-lg-9 col-md-12 Self_Score_tabs_right_part tab-content"
                      id="v-pills-tabContent">
                      <div>
                        <div class="Overall_Cognitive_section my-4" :id="subParam.competencyId"
                          v-for="(subParam, index) in item.competencyTraits" :key="index">
                          <h3>{{ subParam.competencyName }}</h3>

                          <div class="Overall_Cognitive_detail font-size-16 mt-4">
                            <div class="Overall_Cognitive_detail_Definition pb-3">
                              <span class="Recommended_heading_text">
                                Definition
                              </span>
                              <p class="Overall_Cognitive_detail_Definition_content" v-html="subParam.definition">
                              </p>
                            </div>
                            <div class="Overall_Cognitive_detail_Definition mb-5 d-flex">
                              <div class="row align-items-center">
                                <div class="col-xl-9 col-lg-9 col-md-12">
                                  <span class="Recommended_heading_text">
                                    Score Description
                                  </span>
                                  <div v-if="subParam?.comment?.length > 0" class="mt-4">
                                    <p class="Overall_Cognitive_detail_Definition_content" v-html="subParam.comment">
                                    </p>
                                  </div>
                                  <div v-else class="mt-4">
                                    <p class="Overall_Cognitive_detail_Definition_content">
                                      {{ "NA" }}
                                    </p>
                                  </div>
                                </div>
                                <div class="col-xl-3 col-lg-3 col-md-12 text-center">
                                  <CustomChartVue :score="subParam.scoreMain" v-if="subParam.show"
                                    :main="subParam.competencyName" />
                                </div>
                              </div>
                            </div>
                            <div class="Overall_Cognitive_detail_Definition pb-3 mt-4" v-if="subParam.keyFocusArea">
                              <span class="Recommended_heading_text">
                                Key Focus Area
                              </span>
                              <div class="mt-5">
                                <ul class="StepProgress">
                                  <li class="StepProgress-item is-done" v-for="focus in subParam.keyFocusArea"
                                    :key="focus">
                                    {{ focus }}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="behaviouralData.isBehaviouralInterview">
              <div v-if="behaviouralData?.behaviouralInterviewModel != null">
                <div class="Behavioural_IQ_heading_section">
                  Behavioural Interview Questions
                </div>
                <div class="Report_basic_info_heading mt-3">
                  <h4 style="color: #666666; font-weight: 700; font-size: 24px">
                    SUGGESTIONS FOR THE RECRUITER
                  </h4>
                </div>
                <div class="Report_basic_info_area my-2" v-if="
                  this.behaviouralData?.behaviouralInterviewModel
                    ?.suggestedScript
                ">
                  <div class="Score_Rank_chart_area"
                    :class="[this.showFeatureContent == false ? 'disable-text-selection' : '']"
                    :style="{ filter: this.showFeatureContent == false ? 'blur(8px)' : '' }">
                    <div>
                      <span class="Recommended_heading_text text-second">
                        Suggested Script
                        <img src="../../public/dashboard-assets/images/M7/Actions.png" width="20"
                          class="cursor-pointer ms-2" alt="" data-bs-toggle="tooltip" data-bs-placement="top"
                          title="Includes conversational pointers for the recruiters to refer while interviewing the candidates " />
                      </span>

                      <div v-for="itemlist in this.behaviouralData
                        ?.behaviouralInterviewModel?.suggestedScript" :key="itemlist">
                        <ul class="mt-3 text-muted font-size-17" v-if="itemlist.textType == 'Pointer'">
                          <li class="my-2">
                            {{ itemlist.content }}
                            <div v-for="dependentText in itemlist?.dependentTexts" :key="dependentText">
                              <ol v-if="dependentText.textType == 'Pointer'">
                                <li>
                                  {{ dependentText?.content }}
                                </li>
                              </ol>
                              <span v-html="dependentText.content" v-if="dependentText.textType == 'Html'"></span>

                              <div class="mt-3 text-muted font-size-17" v-if="dependentText.textType == 'Paragraph'">
                                <p class="my-2">
                                  {{ dependentText.content }}
                                </p>
                              </div>
                            </div>
                          </li>
                        </ul>
                        <span v-html="itemlist.content" v-if="itemlist.textType == 'Html'"></span>
                        <div class="mt-3 text-muted font-size-17" v-if="itemlist.textType == 'Paragraph'">
                          <p class="my-2">
                            {{ itemlist.content }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="Report_basic_info_area my-2" v-if="
                  this.behaviouralData?.behaviouralInterviewModel
                    ?.basicGuidelines
                ">
                  <div class="Score_Rank_chart_area"
                    :class="[this.showFeatureContent == false ? 'disable-text-selection' : '']"
                    :style="{ filter: this.showFeatureContent == false ? 'blur(8px)' : '' }">
                    <div>
                      <span class="Recommended_heading_text text-second">
                        Basic Guidelines
                        <img src="../../public/dashboard-assets/images/M7/Actions.png" width="20"
                          class="cursor-pointer ms-2" alt="" data-bs-toggle="tooltip" data-bs-placement="top"
                          title="Includes some rules to be kept in mind while interviewing the candidates such as how to observe the candidate, avoidance of environmental distractions, etc. " />
                      </span>
                      <div v-for="itemlist in this.behaviouralData
                        ?.behaviouralInterviewModel?.basicGuidelines" :key="itemlist">
                        <ul class="mt-3 text-muted font-size-17" v-if="itemlist.textType == 'Pointer'">
                          <li class="my-2">
                            {{ itemlist.content }}

                            <div v-for="dependentText in itemlist?.dependentTexts" :key="dependentText">
                              <ol v-if="dependentText.textType == 'Pointer'">
                                <li>
                                  {{ dependentText?.content }}
                                </li>
                              </ol>
                              <span v-html="dependentText.content" v-if="dependentText.textType == 'Html'"></span>

                              <div class="mt-3 text-muted font-size-17" v-if="dependentText.textType == 'Paragraph'">
                                <p class="my-2">
                                  {{ dependentText.content }}
                                </p>
                              </div>
                            </div>
                          </li>
                        </ul>
                        <span v-html="itemlist.content" v-if="itemlist.textType == 'Html'"></span>

                        <div class="mt-3 text-muted font-size-17" v-if="itemlist.textType == 'Paragraph'">
                          <p class="my-2">
                            {{ itemlist.content }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="Report_basic_info_area my-2" v-if="
                  this.behaviouralData?.behaviouralInterviewModel
                    ?.aboutBehaviouralInterview
                ">
                  <div class="Score_Rank_chart_area"
                    :class="[this.showFeatureContent == false ? 'disable-text-selection' : '']"
                    :style="{ filter: this.showFeatureContent == false ? 'blur(8px)' : '' }">
                    <div>
                      <span class="Recommended_heading_text text-second">
                        About Behavioural Interview
                        <img src="../../public/dashboard-assets/images/M7/Actions.png" width="20"
                          class="cursor-pointer ms-2" alt="" data-bs-toggle="tooltip" data-bs-placement="top"
                          title="Includes details on how and why to use behavioural interview question, how to correctly interpret behavioural indicators etc which are given to the recruiter while interviewing the candidate. " />
                      </span>

                      <div v-for="itemlist in this.behaviouralData
                        ?.behaviouralInterviewModel
                        ?.aboutBehaviouralInterview" :key="itemlist">
                        <ul class="mt-3 text-muted font-size-17" v-if="itemlist.textType == 'Pointer'">
                          <li class="my-2">
                            {{ itemlist.content }}
                            <div v-for="dependentText in itemlist?.dependentTexts" :key="dependentText">
                              <ol v-if="dependentText.textType == 'Pointer'">
                                <li>
                                  {{ dependentText?.content }}
                                </li>
                              </ol>
                              <span v-html="dependentText.content" v-if="dependentText.textType == 'Html'"></span>

                              <div class="mt-3 text-muted font-size-17" v-if="dependentText.textType == 'Paragraph'">
                                <p class="my-2">
                                  {{ dependentText.content }}
                                </p>
                              </div>
                            </div>
                          </li>
                        </ul>
                        <span v-html="itemlist.content" v-if="itemlist.textType == 'Html'"></span>
                        <div class="mt-3 text-muted font-size-17" v-if="itemlist.textType == 'Paragraph'">
                          <p class="my-2">
                            {{ itemlist.content }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="this.isBehaviouralInterview">
              <div v-for="(item, index) in this.behaviouralCompetencies" :key="index">
                <div class="Overall_Cognitive_section border_radius_Hp my-4" v-if="
                  item?.interviewQuestions != undefined &&
                  item?.interviewQuestions != null &&
                  item?.interviewQuestions?.length != 0
                ">
                  <div class="Overall_Cognitive_header">
                    {{ item.competencyName }}
                  </div>

                  <div class="Overall_Cognitive_detail mt-4 px-3">
                    <div class="Overall_Cognitive_detail_Definition mb-5">
                      <div class="row">
                        <div class="col-xl-10 col-lg-9 col-md-12 mt-4">
                          <span class="Recommended_heading_text">
                            Definition
                          </span>
                          <p class="Overall_Cognitive_detail_Definition_content">
                            {{ item.definition }}
                          </p>
                        </div>
                        <div class="col-xl-2 col-lg-3 col-md-12 text-center mt-4">
                          <!-- <img src="../../public/dashboard-assets/images/M7/Overall_Cognitive.png" width="130" class="ms-4"
                      alt="" /> -->
                          <CustomChartVue :score="this.subScore[index]" v-if="this.subShow[index]"
                            :main="item.competencyName + '_' + index" />
                        </div>
                      </div>
                    </div>
                    <div class="Report_basic_info_area my-4" v-if="
                      'interviewQuestions' in item &&
                      item?.interviewQuestions?.length != 0
                    ">
                      <span class="Recommended_heading_text">
                        Questions
                        <img src="../../public/dashboard-assets/images/M7/Actions.png" width="20"
                          class="cursor-pointer ms-2" alt="" /></span>
                      <div class="Score_Rank_chart_area" v-for="(Questions, index) in item.interviewQuestions"
                        :key="Questions">
                        <h5 class="mb-3">
                          {{ index + 1 }}. {{ Questions.content }}
                        </h5>

                        <div class="row">
                          <div class="col-lg-6 col-md-12">
                            <ul v-for="Question in Questions.dependentTexts" :key="Question">
                              <li>{{ Question.content }}</li>
                            </ul>
                          </div>
                          <div class="col-lg-6 col-md-12 d-flex justify-content-end">
                            <ul class="U_llist_style_type_N">
                              <li>
                                <input type="radio" name="Questions" id="Ideal" />
                                <label for="Ideal"> Ideal</label>
                              </li>
                              <li>
                                <input type="radio" name="Questions" id="Average" />
                                <label for="Average">Average</label>
                              </li>
                              <li>
                                <input type="radio" name="Questions" id="Lacking" />
                                <label for="Lacking">Lacking</label>
                              </li>
                            </ul>
                          </div>
                        </div>

                        <div class="row justify-content-around">
                          <div class="col-lg-6 col-md-12 mb-3">
                            <div class="Recommendation_Strengths_area">
                              <h3>Positive Indicator</h3>
                              <ul class="nav Recommendation_Strengths_points"
                                v-for="Positive in Questions.positiveIndicator" :key="Positive">
                                <li class="mb-3 d-flex align-items-start">
                                  <img src="../../public/dashboard-assets/images/M7/Behavioural_Page_P_Icon.png"
                                    width="20" height="20" alt="" class="me-2 mt-1" />
                                  <p>{{ Positive.content }}</p>
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div class="col-lg-6 col-md-12 mb-3">
                            <div class="Recommendation_Improvements_area" style="background-color: #fff7fb">
                              <h3>Negative Indicator</h3>

                              <ul class="nav Recommendation_Improvements_points"
                                v-for="Negative in Questions.negativeIndicator" :key="Negative">
                                <li class="mb-3 d-flex align-items-start">
                                  <img src="../../public/dashboard-assets/images/M7/Behavioural_Page_N_Icon.png"
                                    width="20" height="20" alt="" class="me-2 mt-1" />
                                  <p>{{ Negative.content }}</p>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Managerial Counsel -->

            <div v-if="behaviouralData.isManagerialCounsel">
              <div class="Behavioural_IQ_heading_section">
                Managerial Counsel
              </div>
              <div class="Report_basic_info_area my-4" data-v-33297408="">
                <div class="Score_Rank_chart_area" data-v-33297408="">
                  <div data-v-33297408="">
                    <span class="Recommended_heading_text text-second" data-v-33297408="">
                      About Managerial Counsel
                      <img src="../../public/dashboard-assets/images/M7/Actions.png" width="20"
                        class="cursor-pointer ms-2" alt="" /></span>
                    <div class="mt-3" v-for="itemlist in this.behaviouralData.managerialCounsel" :key="itemlist">
                      <ul class="mt-3 text-muted font-size-17" v-if="itemlist.textType == 'Pointer'">
                        <li class="my-2">
                          {{ itemlist.content }}
                          <div v-for="dependentText in itemlist?.dependentTexts" :key="dependentText">
                            <ol v-if="dependentText.textType == 'Pointer'">
                              <li>
                                {{ dependentText?.content }}
                              </li>
                            </ol>
                            <span class="mt-3" v-html="dependentText.content"
                              v-if="dependentText.textType == 'Html'"></span>

                            <div class="mt-3 text-muted font-size-17" v-if="dependentText.textType == 'Paragraph'">
                              <p class="my-2">
                                {{ dependentText.content }}
                              </p>
                            </div>
                          </div>
                        </li>
                      </ul>
                      <span v-html="itemlist.content" v-if="itemlist.textType == 'Html'"></span>
                      <div class="mt-3 text-muted font-size-17" v-if="itemlist.textType == 'Paragraph'">
                        <p class="my-2">
                          {{ itemlist.content }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end -->

            <div>
              <div v-if="behaviouralData.isManagerialCounsel">
                <div class="Behavioural_IQ_heading_section">
                  Managerial Recommendation
                </div>
                <div class="Overall_Cognitive_section border_radius_Hp my-4">
                  <div v-for="Managerial in behaviouralCompetencies" :key="Managerial">
                    <span v-if="Managerial?.managerialRecommendation != null">
                      <span v-if="Managerial?.managerialRecommendation?.length > 0">
                        <div class="Overall_Cognitive_header">
                          {{ Managerial.competencyName }}
                          <span class="Overall_Cognitive_header-low">{{
                            Managerial.fitment
                          }}</span>
                        </div>
                        <div class="Overall_Cognitive_detail mt-4 px-3">
                          <div class="Overall_Cognitive_detail_Definition pb-3">
                            <span class="Recommended_heading_text">
                              Definition
                            </span>
                            <p class="Overall_Cognitive_detail_Definition_content">
                              {{ Managerial.definition }}
                            </p>
                          </div>
                          <!-- <div v-for="(Manageriallist) in Managerial.managerialRecommendation" :key="Manageriallist">
                        <p> {{ Manageriallist }} </p>
                      </div> -->
                          <div class="mt-5">
                            <ul class="StepProgress">
                              <li class="StepProgress-item is-done"
                                v-for="Manageriallist in Managerial.managerialRecommendation" :key="Manageriallist">
                                {{ Manageriallist }}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="Overall_Cognitive_section border_radius_Hp my-4">
            <div class="Overall_Cognitive_header">
              Working Style
              <span class="Overall_Cognitive_header-Average"> Average</span>
            </div>
            <div class="Overall_Cognitive_detail mt-4 px-3">
              <div class="Overall_Cognitive_detail_Definition pb-3">
                <span class="Recommended_heading_text"> Definition </span>
                <p class="Overall_Cognitive_detail_Definition_content">
                  Self Score assesses the candidate's knowledge of English words
                  as well as her/his ability to understand the meaning and usage
                  of words in the given context.
                </p>
              </div>
              <div class="mt-5">
                <ul class="StepProgress">
                  <li class="StepProgress-item is-done">
                    It is understandable that these questions aren’t something
                    you must have prepared.
                  </li>
                  <li class="StepProgress-item is-done">
                    If you need a moment to gather your thoughts before
                    responding, please feel free to do that.
                  </li>
                  <li class="StepProgress-item is-done">
                    It is understandable that these questions aren’t something
                    you must have prepared.It is understandable that these
                    questions aren’t something you must have prepared.It is
                    understandable that these questions aren’t something you
                    must have prepared.
                  </li>
                  <li class="StepProgress-item is-done">
                    Having scored High on Social Boldness, if the candidate’s
                    response to the Behavioural Interview Question is – I loved
                    the fact that all eyes were on me.
                  </li>
                </ul>
              </div>
            </div>
          </div> -->
          </div>
          <!-- end Card -->
          <div class="Report_basic_info_area my-4">
            <div class="Report_basic_info_heading">
              <h4>DISCLAIMER</h4>
            </div>
            <div class="mt-3">
              <span v-html="disclaimer"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="showpdf">
    <BehaviouralPDF :testId="this.testId" :candidateId="this.candidateId" :name="this.name" :isPdf="true" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
// import CustomChartVue from "./CustomChart.vue";
import ActiveTestHeaderVue from "./ActiveTestHeader.vue";
import BehaviouralPDF from "./BehaviouralPDF.vue";
import CustomChartVue from "./CustomChart.vue";
import { Chart, registerables } from "chart.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import { downloadPDF } from "../utils/helper.js";
import { Tooltip } from "bootstrap/dist/js/bootstrap.esm.min.js";
import store from "../store";
import jsPDF from "jspdf";
import Base64Images from "../utils/base64Image.js";
import { SetClarityData } from "../platformFeatures/featureUtils.js";
// import { validatePlanFeatures } from '../platformFeatures/featureUtils';
// import { calculateRemainingDays } from '../platformFeatures/dateUtils';

Chart.register(...registerables);
export default {
  name: "ActiveTestReportBehavioural",
  components: {
    ActiveTestHeaderVue,
    CustomChartVue,
    BehaviouralPDF,
  },
  data() {
    return {
      Remainingdays: 0,
      showpdf: false,
      isShowing: false,
      actived: "Behavioural",
      name: "",//window.atob(this.$route.query.name),
      // candidateId: 10104,
      candidateId: window.atob(this.$route.params.candidateId),
      testId: window.atob(this.$route.params.testId),
      clientId: window.atob(this.$route.query.clientId),
      isParent: window.atob(this.$route.query.isParent),
      routesearch: window.atob(this.$route.query.id),
      routeoffset: window.atob(this.$route.query.offset),
      routecurrent: window.atob(this.$route.query.current),
      GenuineData: "",
      testName: "",
      behaviouralData: "",
      show: false,
      score: {},
      subShow: [],
      subScore: [],
      enabled: [],
      clientCompany: "",
      namePdf: "",
      testNamePDF: "",
      disclaimer: "",
      Companylogo: "",
      isBehaviouralInterview: "",
      reportUrl: "",
      compeleteReportUrl: "",
      behaviouralCompetencies: [],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  created() {
    // this.showFeatureContent  = validatePlanFeatures(this.user.extId, 'User Dashboards & Reports' , 31 , 'Advanced candidate reports');
    // this.showFeatureContentAll  = validatePlanFeatures(this.user.extId, 'User Dashboards & Reports' , 30 , 'General candidate reports');

    // if (this.billing != null) {
    //     this.Remainingdays = calculateRemainingDays(this.billing.object.data.subscription.expiryDate);
    //   } 
    this.reportUrl =
      window.config?.APP_URL +
      "/managecandidates/GetReport?CandidateId=" +
      this.candidateId +
      "&TestId=" +
      this.testId +
      "&Report=Behavioural";

    this.compeleteReportUrl = window.config?.APP_URL + "/managecandidates/GetReport?CandidateId=" + this.candidateId + "&TestId=" + this.testId + "&Report=consolidated";


  },
  async mounted() {

    SetClarityData();

    store.state.loader.isLoading = true;
    await this.GetGenuineData();
    await this.GetBehaviouralData();
    await this.getInfo();
    this.lineChart();
    Array.from(
      document.querySelectorAll('img[data-bs-toggle="tooltip"]')
    ).forEach((tooltipNode) => new Tooltip(tooltipNode));
  },
  unmounted() {
    store.state.loader.isLoading = false;
    this.showpdf = false;
  },
  methods: {
    downloadPDF,
    ...mapActions(["GetGenuineModel", "getBehaviouralData", "getBasicInfo"]),
    scrolling(item, idx) {
      document.getElementById(item).scrollIntoView(true, {
        behavior: "smooth",
        block: "start",
        inline: "start",
      });
      this.behaviouralCompetencies.forEach((element) => {
        if (element.competencyId == idx) {
          element.competencyTraits.forEach((elm) => {
            if (elm.competencyId == item) {
              this.enabled[elm.competencyId] = true;
            } else {
              this.enabled[elm.competencyId] = false;
            }
          });
        }
      });
      /*this.$refs[item].scrollIntoView(true, { behavior: "smooth", block: "start", inline: "start" })*/
    },

    async GetGenuineData() {
      var GenuineData = await this.GetGenuineModel(this.candidateId);
      if (GenuineData?.status) {
        this.GenuineData = GenuineData.object.data;
      } else {
        this.GenuineData = "";
      }
    },
    encode(item) {
      return window.btoa(item);
    },
    async GetBehaviouralData() {
      var response = await this.getBehaviouralData(this.candidateId);
      if (response?.status) {
        store.state.loader.isLoading = false;
        this.behaviouralData = response.object.data;

        this.isBehaviouralInterview =
          response.object.data.isBehaviouralInterview;

        this.score = {
          marksScored: this.behaviouralData?.score,
          outOfMarks: this.behaviouralData?.ranges
            ? this.behaviouralData?.ranges[
              this.behaviouralData?.ranges?.length - 1
            ]?.maxVal
            : null,
          result: this.behaviouralData?.fitment,
          ranges:
            this.behaviouralData?.ranges != null
              ? this.behaviouralData?.ranges
              : [],
        };
        this.show = true;
        this.behaviouralCompetencies = this.behaviouralData.competencies;
        this.behaviouralCompetencies.forEach((element, index) => {


          /*max val*/
          var arr = [];
          element.ranges.forEach((el) => {
            arr.push(el.maxVal);
          });
          var max = [0];
          for (var i = 0; i < arr.length; i++) {
            if (max < arr[i]) {
              max = arr[i];
            }
          }


          this.subShow[index] = false;
          var score = {
            marksScored: element.score,
            outOfMarks: max,
            result: element.fitment,
            ranges: element.ranges,
          };
          this.subScore[index] = score;
          this.subShow[index] = true;

          console.log("All ", this.behaviouralCompetencies);
          console.log("Element ", element);
          console.log("Score ", score);



          /*parameter*/
          if (element.competencyTraits) {
            element.competencyTraits.forEach((elm, idx) => {
              if (idx == 0) {
                this.enabled[elm.competencyId] = true;
              } else {
                this.enabled[elm.competencyId] = false;
              }
              var ar = [];
              element.ranges.forEach((el) => {
                ar.push(el.maxVal);
              });
              var mx = Math.max.apply(null, ar);
              elm.show = false;
              var score = {
                marksScored: elm.score,
                outOfMarks: mx,
                result: elm.fitment,
                ranges: elm.ranges,
              };
              elm.scoreMain = score;
              elm.show = true;
            });
          }
        });
      }
    },

    lineChart() {
      var labels = [];
      var score = [];
      var stemRanges = [];
      var stemLabels = [];
      var stemColors = [];

      // this.behaviouralCompetencies.sort(({ competencyId: a }, { competencyId: b }) => b - a).forEach((elm, index) => {
      //   labels.push(elm.competencyName);
      //   score.push(elm.score);
      this.behaviouralCompetencies.forEach((elm, index) => {
        labels.push(elm.competencyName);
        score.push(elm.score);

        //console.log("Score from Line Graph:", ({ competencyId: a }, { competencyId: b }) => b - a);
        if (index == 0) {
          elm.ranges.forEach((item) => {
            stemRanges.push({
              Name: item.rangeName,
              From: item.minVal,
              To: item.maxVal,
              ColorCode: item.colorCode,
            });
          });
        }

        var assignedRange = false;
        stemRanges.forEach((ele) => {
          if (!assignedRange && elm.score >= ele.From && elm.score <= ele.To) {
            stemLabels.push(ele.Name + "(" + ele.From + "-" + ele.To + ")");
            stemColors.push(ele.ColorCode);
            assignedRange = true;
          }
        });
      });
      // Calculate the desired height based on the number of data points
      var baseHeightPerDataPoint = 50; // Adjust this value as needed
      var desiredHeight = score.length * baseHeightPerDataPoint;

      // Set the height of the chart container
      var chartContainer = document.getElementById("myChart");
      chartContainer.style.height = desiredHeight + "px";

      var ctx = document.getElementById("myChart").getContext("2d");
      var chart = new Chart(ctx, {
        type: "line",
        data: {
          labels: labels,
          datasets: [
            {
              data: score,
              strokeColor: "#7B818D",
              pointBackgroundColor: "#FFFFFF",
              backgroundColor: stemColors,
              borderWidth: 3,
              borderColor: "#7B818D",
              pointHitRadius: 3,
              pointPadding: 12,
              pointBorderColor: stemColors,
              pointBorderWidth: 6,
              pointRadius: 10,
              tension: 0.1
            },
          ],
        },
        options: {
          layout: {
            padding: {
              top: 30,
            },
          },
          indexAxis: "y",
          scales: {
            y: {
              ticks: {
                font: {
                  size: 14,
                },
                padding: 10,
              },
              grid: {
                display: false,
              },
              title: {
                display: true,
                color: "black",
                text: "Competencies",
              },
            },
            x: {
              beginAtZero: true,
              ticks: {
                font: {
                  size: 14,
                },
              },
              grid: {
                color: function (context) {
                  var gridColor = "#000000";
                  stemRanges.forEach((item) => {
                    if (
                      context.tick.value >= item.From &&
                      context.tick.value <= item.To
                    ) {
                      gridColor = item.ColorCode;
                    }
                  });

                  return gridColor;
                },
                lineWidth: 1,
              },
              suggestedMin: 0,
              suggestedMax: 10,
              title: {
                display: true,
                text: "Score",
                color: "black",
              },
            },
          },
          plugins: {
            customPlugin: {
              consoleText: "testText",
              color: "black",
            },
            legend: {
              display: false,
              position: "top",
            },
            tooltip: {
              enabled: true
            }
          },
        },
        plugins: [
          {
            id: "customPlugin",
            beforeDraw: (chart) => {
              var ctx = chart.ctx;
              var chartArea = chart.chartArea;
              var columnCount = chart.scales["x"].ticks.length - 1;
              var width = chart.scales["x"].width; //chartArea.right - chartArea.left;
              var height = chartArea.bottom - chartArea.top;
              var columnWidth = width / columnCount;
              ctx.save();
              var startPoint = 0;
              var stemCounter = 0;
              if (!chartArea.isHorizontal) {
                //vertical background
                var colorDisplay = "";
                startPoint = chartArea.left;
                var matched = false;
                while (startPoint < chartArea.right) {
                  stemRanges.forEach((item) => {
                    if (
                      stemCounter >= item.From &&
                      stemCounter < item.To &&
                      matched == false
                    ) {
                      var m = item.ColorCode.match(
                        /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i
                      );
                      colorDisplay =
                        "rgb(" +
                        parseInt(m[1], 16) +
                        "," +
                        parseInt(m[2], 16) +
                        "," +
                        parseInt(m[3], 16) +
                        ", 0.1)";
                      stemCounter = stemCounter + 1;
                      matched = true;
                    }
                  });
                  matched = false;
                  ctx.fillStyle = colorDisplay;
                  ctx.fillRect(startPoint, chartArea.top, columnWidth, height);
                  startPoint += columnWidth;
                }
              }
              ctx.restore();
            },
          },
          {
            id: "customLegend",
            afterUpdate: () => {
              const legendContainer =
                document.getElementById("legend-container");

              let listContainer = legendContainer.querySelector("div");

              if (!listContainer) {
                listContainer = document.createElement("div");
                listContainer.style.display = "flex";
                listContainer.style.flexDirection = "row";
                listContainer.style.margin = 0;
                listContainer.style.padding = 0;
                listContainer.style.justifyContent = "center";

                legendContainer.appendChild(listContainer);
              }

              // Remove old legend items
              while (listContainer.firstChild) {
                listContainer.firstChild.remove();
              }

              stemRanges.forEach((item) => {
                // Color box
                const boxSpan = document.createElement("div");
                boxSpan.style.background = item.ColorCode;
                boxSpan.style.borderRadius = "50%";
                boxSpan.style.display = "inline-block";
                boxSpan.style.marginRight = "10px";
                boxSpan.style.width = "20px";
                boxSpan.style.height = "20px";
                // Text
                const textContainer = document.createElement("div");
                textContainer.style.color = "#666666";

                textContainer.style.padding = 0;
                textContainer.style.fontSize = "15px";
                textContainer.style.whiteSpace = "nowrap";
                textContainer.style.fill = "#666666";
                textContainer.style.marginRight = "1rem";
                textContainer.style.fontWeight = "bold";

                const text = document.createTextNode(
                  item.Name + " (" + item.From + " - " + item.To + ")"
                );
                textContainer.appendChild(text);

                listContainer.appendChild(boxSpan);
                listContainer.appendChild(textContainer);
              });
            },
          },
        ],
      });
      for (var i = 0; i < chart.data.datasets[0].data.length; i++) {
        stemRanges.forEach((item) => {
          if (
            chart.data.datasets[0].data[i] >= item.From &&
            chart.data.datasets[0].data[i] <= item.To
          ) {
            chart.data.datasets[0].pointBorderColor.push(item.ColorCode);
          }
        });
      }
      chart.update();
    },
    async getInfo() {
      var info = await this.getBasicInfo(this.candidateId);
      if (info?.status) {
        this.BasicInfoData = info.object.data;
        this.testName = this.BasicInfoData.testName;
        this.name = this.BasicInfoData.name;
        this.disclaimer = this.BasicInfoData.disclaimer;
        // this.clientCompany = "data:image/png;base64,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";
        // this.Companylogo = "data:image/png;base64,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";
        this.clientCompany = this.BasicInfoData.clientCompanyLogo;
        this.Companylogo = this.BasicInfoData.companyLogo;

        this.namePdf = this.BasicInfoData.name;
        this.testNamePDF = this.BasicInfoData.testName;
      } else {
        this.BasicInfoData = null;
      }
    },
    async savePdf() {
      store.state.loader.isLoading = true;
      this.showpdf = true;

      // const doc = new jsPDF("p", "mm", "a4" ); // Create a new instance of jsPDF with A4 dimensions
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
        // autoPaging: "text"
      }); // Create a new instance of jsPDF with A4 dimensions
      const namePdf = this.namePdf;
      const testName = this.testNamePDF;
      const Companylogo = this.Companylogo;
      const clientCompany = this.clientCompany;
      setTimeout(() => {
        const element = document.getElementById("behaviour");
        const container = document.createElement("div");
        // Append the container to the element
        element.appendChild(container);

        doc.html(element, {
          margin: [25, 0, 25, 0],
          x: 0,
          y: 0,
          autoPaging: "text",
          callback: function (pdf) {
            // footer start
            const footerContainer = document.createElement("div");
            // Append the footer container to the element
            element.appendChild(footerContainer);
            const pageCount = doc.internal.getNumberOfPages(); // Get the total number of pages in the PDF document
            for (let i = 1; i <= pageCount; i++) {
              doc.setPage(i);
              // header start
              if (i === 1) {
                var imageUrl = Base64Images.Background;
                // Add the background image
                doc.addImage(
                  imageUrl,
                  "PNG",
                  0,
                  0,
                  doc.internal.pageSize.getWidth(),
                  doc.internal.pageSize.getHeight()
                );
                // logo 1
                const img1 = document.createElement("img");
                img1.setAttribute("src", Companylogo);

                const imageWidth = 40; // Width of each image
                const imageHeight = 10; // Height of each image
                const imageX1 = 10; // X position of the first image
                const imageY1 = 5; // Y position of the first image
                doc.addImage(
                  img1.src,
                  "JPEG",
                  imageX1,
                  imageY1,
                  imageWidth,
                  imageHeight
                );
                // console.log(img1)
                // logo-2
                const img2 = document.createElement("img");
                img2.setAttribute("src", clientCompany);
                const image2Width = 40; // Width of each image
                const image2Height = 10; // Height of each image
                const imageX2 = doc.internal.pageSize.width - image2Width - 10; // X position of the image on the right
                const imageY2 = 5; // Y position of the image
                doc.addImage(
                  img2.src,
                  "JPEG",
                  imageX2,
                  imageY2,
                  image2Width,
                  image2Height
                );
              } else {
                // header 2
                doc.setFillColor(232, 247, 250); // Set the fill color to red (change the RGB values as per your desired color)
                doc.rect(0, 0, doc.internal.pageSize.getWidth(), 20, "F"); // Draw a filled rectangle as the header background

                // logo 1
                const img1 = document.createElement("img");
                img1.setAttribute("src", Companylogo);

                const imageWidth = 40; // Width of each image
                const imageHeight = 10; // Height of each image

                const imageX1 = 10; // X position of the first image
                const imageY1 = 5; // Y position of the first image
                doc.addImage(
                  img1.src,
                  "JPEG",
                  imageX1,
                  imageY1,
                  imageWidth,
                  imageHeight
                );

                doc.setFontSize(10);

                // Set the header text margin

                // Specify the content of the header text
                const headerText = `${testName}`;

                // Calculate the x-position to center the header text
                const textWidth =
                  (doc.getStringUnitWidth(headerText) *
                    doc.internal.getFontSize()) /
                  doc.internal.scaleFactor;
                const x = (doc.internal.pageSize.getWidth() - textWidth) / 2;

                // Add the header text at the centered position
                doc.text(headerText, x, 10);

                // logo-2

                const img2 = document.createElement("img");
                img2.setAttribute("src", clientCompany);
                const image2Width = 40; // Width of each image
                const image2Height = 10; // Height of each image
                const imageX2 = doc.internal.pageSize.width - image2Width - 10; // X position of the image on the right
                const imageY2 = 5; // Y position of the image
                doc.addImage(
                  img2.src,
                  "JPEG",
                  imageX2,
                  imageY2,
                  image2Width,
                  image2Height
                );
              }
              // footer start
              doc.setFontSize(15);
              doc.setTextColor(41, 46, 52, 1);
              const img3 = document.createElement("img");
              img3.setAttribute("src", Base64Images.Footer);

              const image3Width = doc.internal.pageSize.width; // Width of the image (equal to the page width)
              const image3Height = 20; // Height of the image
              const imageX3 = 0; // X position of the image (start from the left)
              const imageY3 = doc.internal.pageSize.height - image3Height;
              doc.addImage(
                img3,
                "JPEG",
                imageX3,
                imageY3,
                image3Width,
                image3Height
              );

              const footerText = "";
              const pageNumber = "Behavioural " + " | " + i;
              const textWidth = doc.getTextWidth(footerText); // Calculate the width of the footer text
              const xPos = doc.internal.pageSize.width - textWidth - 40; // 10 is the margin from the right side
              // Add footer text aligned to the right
              doc.text(footerText, xPos, doc.internal.pageSize.height - 10);
              // Add page number aligned to the right
              doc.text(pageNumber, xPos, doc.internal.pageSize.height - 5);
            }
            // end footer
            const pdfDataUri = pdf.output("datauristring");
            const link = document.createElement("a");
            link.href = pdfDataUri;
            link.download = `Behavioural_${namePdf}.pdf`;

            store.state.loader.isLoading = false;
            link.click();
          },
        });
        setTimeout(() => {
          this.showpdf = false;
        }, 2 * 1000);
      }, 1 * 60 * 1000);
    },
  },
};
</script>

<style scoped>
/* .linechart canvas {
  height: 350px !important;
} */
.response-table-headers {
  font-weight: bold;
  font-size: 16px;
}

.show-not-genuine-fitment {
  color: #cf1902;
}

.disable-text-selection {
  user-select: none;
}
</style>
